// import components
import { styled, Box } from '@mui/material';

export const StyledToolbarContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  marginBottom: theme.spacing(6)
}));

export const StyledToolbarMainBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2)
}));
